export default __webpack_public_path__ + "static/media/community-defi-icon.b94e0bb2.png";